"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_contexify_1 = require("react-contexify");
const Icon_1 = require("../../elements/Icon");
const ContextMenuContext_1 = require("./ContextMenuContext");
const lib_1 = require("../../lib");
const MenuItem = (_a) => {
    var { icon, children, selected, onClick, fullWidth, danger, interactive } = _a, rest = (0, tslib_1.__rest)(_a, ["icon", "children", "selected", "onClick", "fullWidth", "danger", "interactive"]);
    const { onItemClick } = (0, react_1.useContext)(ContextMenuContext_1.ContextMenuContext);
    const handleClick = (args) => {
        if (interactive)
            args.event.stopPropagation();
        if (onClick)
            onClick(args);
        onItemClick();
    };
    return ((0, jsx_runtime_1.jsxs)(react_contexify_1.Item, Object.assign({}, rest, { onClick: handleClick, className: (0, lib_1.bem)("context-menu__item", (0, lib_1.use)(danger, "--danger"), (0, lib_1.use)(interactive, "--interactive")) }, { children: [!fullWidth && !interactive && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: icon && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "context-menu__icon" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: icon, className: "context-menu__icon-svg" }, void 0) }), void 0)) }, void 0)), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "context-menu__content" }, { children: children }), void 0), selected && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "context-menu__icon context-menu__icon--selected" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "check", className: "context-menu__icon-svg context-menu__icon-svg--selected" }, void 0) }), void 0))] }), void 0));
};
exports.MenuItem = MenuItem;
//# sourceMappingURL=MenuItem.js.map